export default "__VITE_ASSET__DJpZT0bi__"